<template>
  <dialog-add
    icon="business_center"
    :title="title"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-creator-program-business class="elevation-1" />
    </template>
  </dialog-add>
</template>

<script>
export default {
  methods: {
    onCancel() {
      this.$router.push('/creator-program/businesses');
    },
  },
  computed: {
    title() {
      if (this.$route.name === 'creator-program-businesses-new') {
        return this.$t('create_business');
      } else {
        return this.$t('change_business');
      }
    },
  },
};
</script>
